<template>
  <div class="usp-section flex justify-center">
    <div>
      <div class="grid lg:grid-cols-3 gap-16 lg:gap-8 content-wrapper">
        <div class="usp-box">
          <div class="flex justify-center mb-8">
            <img
              class="h-24 max-w-max"
              src="@/assets/images/icon-home-office-filter.svg"
            />
          </div>
          <h4 class="mb-2">6 Schritte zu Deinem Job-Match</h4>
          <p>
            Investiere eine Minute Deiner Zeit und lass Dir die besten
            Jobangebote anzeigen.
          </p>
        </div>
        <div class="usp-box">
          <div class="flex justify-center mb-8">
            <img
              class="h-24 max-w-max"
              src="@/assets/images/icon-xing-guide.svg"
            />
          </div>
          <h4 class="mb-2">Der Job-Agent bringt Dich weiter</h4>
          <p>
            Mit den Filtern im Job-Agenten kannst Du Ergebnisse nach Deinen
            Wünschen steuern.
          </p>
        </div>
        <div class="usp-box">
          <div class="flex justify-center mb-8">
            <img
              class="h-24 max-w-max"
              src="@/assets/images/icon-compass.svg"
            />
          </div>
          <h4 class="mb-2">Finde den Job der wirklich passt</h4>
          <p>
            Wir zeigen Dir Deine Ergebnisse direkt an oder wir senden sie in
            Dein Postfach.
          </p>
        </div>
      </div>
      <div class="flex justify-center mt-12">
        <CallToActionButton @clicked="$emit('launchAgent')"
          >Zum Job-Agenten</CallToActionButton
        >
      </div>
    </div>
  </div>
</template>

<script>
import CallToActionButton from "../form/CallToActionButton.vue";
export default {
  name: "UspSection",
  components: { CallToActionButton },
};
</script>
